import { UserLinkDto } from '@/types';

const MembershipLevelBadge = ({ user }: { user: UserLinkDto }) => {
  const { membershipLevel } = user;

  if (!membershipLevel) return null;
  return (
    <div
      className={`rounded-full text-white capitalize py-2 px-3 font-bold text-sm ${
        membershipLevel === 'Pro'
          ? 'bg-purple'
          : membershipLevel === 'Charity'
          ? 'bg-green-500'
          : membershipLevel === 'VIP'
          ? 'bg-yellow-400'
          : 'bg-blue-5c'
      }`}
    >
      {membershipLevel}
    </div>
  );
};

export default MembershipLevelBadge;
